(function(){
  'use strict';
  // Guard against double-execution (script loaded twice in theme.liquid)
  if (window._hcWishlistLoaded) return;
  window._hcWishlistLoaded = true;

  var STORAGE_KEY = 'hc-wishlist-items';
  var WISHLIST_URL = '/pages/wishlist';

  function getItems() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); } catch(e) { return []; }
  }
  function saveItems(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); } catch(e) {}
  }
  function isInWishlist(handle) {
    return getItems().some(function(i) { return i.handle === handle; });
  }
  function addItem(p) {
    var items = getItems();
    if (!items.some(function(i) { return i.handle === p.handle; })) {
      items.push(p);
      saveItems(items);
    }
  }
  function removeItem(handle) {
    saveItems(getItems().filter(function(i) { return i.handle !== handle; }));
  }
  function updateCount() {
    var count = getItems().length;
    document.querySelectorAll('.hc-wishlist-count').forEach(function(b) {
      b.textContent = count > 0 ? count : '';
      b.style.display = count > 0 ? 'inline-flex' : 'none';
    });
  }
  function updateButtons() {
    document.querySelectorAll('.hc-wishlist-btn').forEach(function(btn) {
      var active = isInWishlist(btn.dataset.productHandle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('hc-in-wishlist', active);
      var path = btn.querySelector('svg path');
      if (path) path.setAttribute('fill', active ? 'currentColor' : 'none');
    });
  }
  function handleClick(btn) {
    var handle = btn.dataset.productHandle;
    if (isInWishlist(handle)) {
      removeItem(handle);
    } else {
      addItem({
        id: btn.dataset.productId,
        handle: handle,
        title: btn.dataset.productTitle,
        vendor: btn.dataset.productVendor,
        price: btn.dataset.productPrice,
        currency: btn.dataset.productCurrency,
        image: btn.dataset.productImage,
        variantId: btn.dataset.variantId,
        url: '/products/' + handle
      });
    }
    updateButtons();
    updateCount();
  }
  function renderWishlistPage() {
    var container = document.getElementById('hc-wishlist-container');
    if (!container) return;
    var items = getItems();
    if (items.length === 0) {
      container.innerHTML = '<div class="hc-wl-empty"><p>Your wishlist is empty.</p><a href="/collections/all" class="hc-wl-view">Shop Now</a></div>';
      return;
    }
    var html = '<div class="hc-wl-grid">';
    items.forEach(function(item) {
      var imgSrc = item.image || '';
      var price = item.currency + ' $' + parseFloat(item.price || 0).toFixed(2);
      html += '<div class="hc-wl-item">';
      html += '<a href="' + item.url + '" class="hc-wl-img-wrap"><img src="' + imgSrc + '" alt="' + item.title + '" loading="lazy"></a>';
      html += '<div class="hc-wl-info">';
      html += '<a href="' + item.url + '" class="hc-wl-title">' + item.title + '</a>';
      html += '<p class="hc-wl-price">' + price + '</p>';
      html += '<div class="hc-wl-actions">';
      html += '<a href="' + item.url + '" class="hc-wl-view">View Product</a>';
      html += '<button class="hc-wl-remove" data-handle="' + item.handle + '">Remove</button>';
      html += '</div></div></div>';
    });
    html += '</div>';
    container.innerHTML = html;
    container.querySelectorAll('.hc-wl-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        removeItem(btn.dataset.handle);
        renderWishlistPage();
        updateCount();
      });
    });
  }
  function init() {
    // Update all wishlist nav links to point to the correct page
    document.querySelectorAll('.hc-wishlist-nav').forEach(function(a) {
      a.setAttribute('href', WISHLIST_URL);
    });
    // Handle wishlist button clicks via event delegation
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.hc-wishlist-btn');
      if (btn) {
        e.preventDefault();
        handleClick(btn);
      }
    });
    updateButtons();
    updateCount();
    renderWishlistPage();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();